import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
const enTranslations = {
  // Navigation
  nav: {
    home: 'Home',
    research: 'Research',
    notes: 'Notes',
    about: 'About',
    cv: 'CV',
    contact: 'Contact',
    privacy: 'Privacy',
    cookies: 'Cookies',
    terms: 'Terms',
  },
  // Common UI
  common: {
    loading: 'Loading...',
    error: 'Something went wrong',
    notFound: 'Page not found',
    backToSite: 'Back to site',
    scrollToExplore: 'Scroll to explore',
    viewAll: 'View all',
    readMore: 'Read more',
    published: 'Published',
    draft: 'Draft',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
  },
  // Home page
  home: {
    subtitle: 'Curatorial Practice & Research',
    selectedResearch: 'Selected Research',
    fromReadingRoom: 'From the Reading Room',
    enterReadingRoom: 'Enter reading room',
    getInTouch: 'Get in touch',
  },
  // Research
  research: {
    title: 'Research',
    subtitle: 'Ongoing and completed research projects',
    noProjects: 'No published research projects yet.',
    phases: 'Project Phases',
  },
  // Notes
  notes: {
    title: 'Notes',
    subtitle: 'Reading Room',
    description: 'Reflections, readings, and fragments from ongoing research.',
    noNotes: 'No notes published yet.',
    references: 'References',
    by: 'By',
  },
  // About
  about: {
    title: 'About',
  },
  // Contact
  contact: {
    title: 'Contact',
    getInTouch: 'Get in Touch',
    email: 'Email',
    location: 'Location',
  },
  // Footer
  footer: {
    copyright: 'All rights reserved',
    builtWith: 'Built with intention',
  },
  // Admin
  admin: {
    dashboard: 'Dashboard',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    signInToManage: 'Sign in to manage content',
    forgotPassword: 'Forgot password?',
    email: 'Email',
    password: 'Password',
    pages: 'Pages',
    notesTab: 'Notes',
    projects: 'Projects',
    media: 'Media',
    policies: 'Policies',
    settings: 'Settings',
    setup: 'Setup',
  },
};

// Arabic translations - Localized with DeepL-quality translations
const arTranslations = {
  // Navigation
  nav: {
    home: 'الرئيسية',
    research: 'البحث',
    notes: 'الديوان',
    about: 'نبذة عني',
    cv: 'السيرة الذاتية',
    contact: 'اتصل بي',
    privacy: 'سياسة الخصوصية',
    cookies: 'سياسة ملفات تعريف الارتباط',
    terms: 'شروط الاستخدام',
  },
  // Common UI
  common: {
    loading: 'جارٍ التحميل...',
    error: 'حدث خطأ ما',
    notFound: 'الصفحة غير موجودة',
    backToSite: 'العودة إلى الموقع',
    scrollToExplore: 'مرّر للاستكشاف',
    viewAll: 'عرض الكل',
    readMore: 'اقرأ المزيد',
    published: 'منشور',
    draft: 'مسودة',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    close: 'إغلاق',
  },
  // Home page
  home: {
    subtitle: 'ممارسة بحثية وتنسيقية',
    selectedResearch: 'أبحاث مختارة',
    fromReadingRoom: 'من الديوان',
    enterReadingRoom: 'ادخل الديوان',
    getInTouch: 'تواصل معي',
  },
  // Research
  research: {
    title: 'البحث',
    subtitle: 'مشاريع بحثية قيد التنفيذ ومكتملة',
    noProjects: 'لا توجد مشاريع بحثية منشورة بعد.',
    phases: 'مراحل المشروع',
  },
  // Notes
  notes: {
    title: 'دفتر الملاحظات',
    subtitle: 'الديوان',
    description: 'تأملات وقراءات ومقتطفات من البحث الجاري.',
    noNotes: 'لا توجد ملاحظات منشورة بعد.',
    references: 'المراجع',
    by: 'بقلم',
  },
  // About
  about: {
    title: 'نبذة عني',
  },
  // Contact
  contact: {
    title: 'اتصل بي',
    getInTouch: 'تواصل معي',
    email: 'البريد الإلكتروني',
    location: 'الموقع الجغرافي',
  },
  // Footer
  footer: {
    copyright: 'جميع الحقوق محفوظة',
    builtWith: 'صُمم بعناية',
  },
  // Admin
  admin: {
    dashboard: 'لوحة التحكم',
    signIn: 'تسجيل الدخول',
    signOut: 'تسجيل الخروج',
    signInToManage: 'سجّل دخولك لإدارة المحتوى',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    pages: 'الصفحات',
    notesTab: 'الملاحظات',
    projects: 'المشاريع',
    media: 'الوسائط',
    policies: 'السياسات',
    settings: 'الإعدادات',
    setup: 'الإعداد',
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      ar: { translation: arTranslations },
    },
    fallbackLng: 'en',
    defaultNS: 'translation',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
